export default {
  required: 'Povinné pole.',
  num_max: 'Maximální hodnota je {{max}}.',
  str_max: 'Musí obsahovať maximálne {{count}} znaků.',
  array_min: 'Musí obsahovat nejméně {{count}} položek',
  invalid_email: 'E-mail musí být ve validním formátě',
  num_min: 'Minimální hodnota je {{min}}.',
};
